/**
 * Common Ethereum protocol versions
 */

/** @type {import('./ProtocolVersionType.js').ProtocolVersionType} */
export const ETH_66 =
	/** @type {import('./ProtocolVersionType.js').ProtocolVersionType} */ (
		"eth/66"
	);

/** @type {import('./ProtocolVersionType.js').ProtocolVersionType} */
export const ETH_67 =
	/** @type {import('./ProtocolVersionType.js').ProtocolVersionType} */ (
		"eth/67"
	);

/** @type {import('./ProtocolVersionType.js').ProtocolVersionType} */
export const ETH_68 =
	/** @type {import('./ProtocolVersionType.js').ProtocolVersionType} */ (
		"eth/68"
	);

/** @type {import('./ProtocolVersionType.js').ProtocolVersionType} */
export const SNAP_1 =
	/** @type {import('./ProtocolVersionType.js').ProtocolVersionType} */ (
		"snap/1"
	);
